import { Component, HostListener, OnDestroy, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ActivateComponentService } from '@shared/services/activate-component.service';
import { GridSync } from '@grid/models';

@Component({
  template: '',
})
export abstract class DeactivationGuardedComponent implements OnDestroy {
  protected activatedComponentService = inject(ActivateComponentService);

  constructor() {
    this.activateComponent();
  }

  @HostListener('window:beforeunload')
  alertUnsavedChanges(): boolean {
    if (!this.canDeactivate) {
      return true;
    }
    if (!this.canDeactivate()) {
      return false;
    }
    return true;
  }

  //#region Lifecycle hooks

  ngOnDestroy(): void {
    this.deactivateComponent();
  }

  //#endregion

  protected activateComponent(): void {
    this.activatedComponentService.activatedComponent.next(this);
  }

  protected deactivateComponent(): void {
    this.activatedComponentService.activatedComponent.next(null);
  }

  abstract canDeactivate(): boolean | Observable<boolean>;

  abstract save<T>(
    changes?: GridSync<T>,
    isAutoSync?: boolean,
    isAutoSyncFromAdminChange?: boolean
  ): Observable<boolean>;
}
